var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCheckIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_3994423_checkmark_complete_correct_done_yes_icon",
    "data-name": "3994423_checkmark_complete_correct_done_yes_icon",
    xmlns: "http://www.w3.org/2000/svg",
    width: 31.879,
    height: 31.879,
    viewBox: "0 0 31.879 31.879",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_10696",
    "data-name": "Path 10696",
    d: "M37.428,30.717,32.315,36.85,30.525,34.7a1.991,1.991,0,0,0-3.059,2.549l3.319,3.985a1.99,1.99,0,0,0,3.059,0l6.643-7.97a1.992,1.992,0,1,0-3.059-2.553Z",
    transform: "translate(-18.037 -20.039)",
    fill: "#3254fe"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_10697",
    "data-name": "Path 10697",
    d: "M15.939,0A15.939,15.939,0,1,0,31.879,15.939,15.939,15.939,0,0,0,15.939,0Zm0,27.894A11.955,11.955,0,1,1,27.894,15.939,11.955,11.955,0,0,1,15.939,27.894Z",
    fill: "#3254fe"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckIcon);
export default __webpack_public_path__ + "static/media/check-icon.9a7fe13931a0a667f5526083a5174c32.svg";
export { ForwardRef as ReactComponent };